import React from 'react';
import { useRouter } from 'next/router';
import { Card, Table } from '@avila-tek/ui/src';
import { createColumnHelper } from '@tanstack/react-table';
import { PageInfo, Pagination, Tax } from '../../models';
import { ActiveDotCell } from '../shared';

const columnHelper = createColumnHelper<Tax>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Nombre',
  }),

  columnHelper.accessor('value', {
    header: 'Valor porcentual',
    cell: (info) => `${info.getValue()}%`,
  }),

  columnHelper.accessor('active', {
    header: 'Estatus',
    cell: (info) => <ActiveDotCell active={info?.getValue()} />,
  }),
];

interface TaxTableProps {
  data: Pagination<Tax>;
  pagination: Partial<PageInfo>;
  setPagination: React.Dispatch<React.SetStateAction<Partial<PageInfo>>>;
}

function TaxTable({ data, pagination, setPagination }: TaxTableProps) {
  const router = useRouter();

  const onClickRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    router.push(`/app/settings/taxes/${id}`);
  };

  const onClickAddButton = () => router.push('/app/settings/taxes/create');

  const handleGoToPage = (value: number) => {
    setPagination({ ...pagination, currentPage: value });
  };

  return (
    <Card className="overflow-x-auto p-5">
      <Table<Tax>
        data={data.items}
        columns={columns}
        href="/app/settings/taxes/create"
        manualPagination
      >
        <Table.Header>
          <Table.SearchInput />
          <Table.AddButton title="Impuesto" action={onClickAddButton} />
        </Table.Header>
        <Table.Content<Tax> onClickRow={onClickRow} />
        <Table.Footer>
          <Table.Pagination
            handleGoToPage={handleGoToPage}
            paginationInfo={{
              count: data.count,
              pageInfo: { ...data.pageInfo },
            }}
            className="ml-auto"
          />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default TaxTable;
